/**
 * Returns a square placeholder image from picsum.photos for a brand.
 * Each brand gets a unique, deterministic image via a seed derived from its name.
 * Will be replaced with real logos uploaded via the CMS.
 */
export function brandLogo(name: string): string {
  // Simple hash to get a consistent image per brand name
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = ((hash << 5) - hash + name.charCodeAt(i)) | 0;
  }
  const id = Math.abs(hash) % 1000;
  return `https://picsum.photos/seed/${id}/160/160`;
}
